import { Ref, computed, ref } from "vue";

export function useSearchFilter<T>(list: Ref<T[] | undefined>, filterProperty: keyof T) {
  const searchInput = ref<string>("");

  const filteredList = computed<T[]>(() => {
    if (!searchInput.value || !searchInput.value.length) {
      return list.value ?? [];
    }

    return (
      list.value?.filter((item) => {
        if (typeof item[filterProperty] === "string") {
          return (item[filterProperty] as string).toLowerCase().includes(searchInput.value.toLowerCase());
        }

        return [`${item[filterProperty]}`].includes(searchInput.value.toLowerCase());
      }) ?? []
    );
  });

  function resetSearchInput() {
    searchInput.value = "";
  }

  return {
    searchInput,
    filteredList,
    resetSearchInput,
  };
}
